import * as React from 'react'
function SvgCheck(props) {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 40 40"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M15.2 25.2l-5-5A1.98 1.98 0 007.4 23l6.386 6.386a2 2 0 002.828 0L32.6 13.4a1.98 1.98 0 00-2.8-2.8L15.2 25.2z"
				fill="currentColor"
				fillRule="evenodd"
			/>
		</svg>
	)
}
export default SvgCheck
